import type { IMasterDataRetailerRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataRetailerDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataRetailerUseCase {
  private readonly repository: IMasterDataRetailerRepository;

  constructor(repository: IMasterDataRetailerRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataRetailerDTO) {
    return this.repository.updateRetailer(params);
  }
}
